export default __webpack_public_path__ + "static/media/Gilroy-Regular.31d54a4b.woff";